import React from 'react';

import './styles.css';

import Logo from '../../assets/logo.svg';
import LogoIfpb from '../../assets/logoIfpb.svg';
import Loopis from '../../assets/LogoPNG.png'

export default function About() {
  return (
    <div id="about-section">
    
      <div id="img-about">
        <div id="div-about"> 
          <div id="text-about">   
            <h1>Sobre o evento</h1>
            <p>
              Nos últimos meses, nosso planeta foi surpreendido pela contaminação do vírus Sars-CoV-2, o que levou a Organização Mundial da Saúde (OMS) a anunciar emergência de saúde pública global e a caracterizar a rápida transmissão desse vírus, que causa a COVID-19, como uma pandemia.
            </p>
            <p>
              Diante desse desafio, e da necessidade de reflexão sobre temas socioambientais, promovida pela ONU desde 5 de junho de 1972 – Dia Mundial do Meio Ambiente,  as Comissões de Gerenciamento dos Resíduos Sólidos e de Políticas  Ambientais do IFPB - Campus Cajazeiras, que vem desenvolvendo e executando ações para proporcionar maior engajamento da comunidade, destaca entre as iniciativas, neste momento em que precisamos ficar em casa, a implementação de um evento exclusivamente virtual, que contará com uma vasta programação nos dias 03, 04 e 05 de junho de 2020. No decorrer do evento teremos: lives, webinares, oficinas virtuais, concurso ambiental e cine debate, tudo para estarmos mais próximos, virtualmente, para conversarmos, aprendermos e compartilharmos vivências, opiniões e conhecimentos.
            </p>
          </div>
        </div>
      </div>    

      <footer id="footer-home">
          <div id="information-footer">
             <div id="map">
               <h1>Mapa</h1>

               <a href="#programmation-container">PROGRAMAÇÃO</a>
               <a href="#submit-container">SUBMISSÃO</a>
               <a href="#contest-section">CONCURSO</a>
             </div>

             <img className="loopis" src={Loopis} alt="Loopis"/>

              <div id="image-footer-box">
                <img src={Logo} alt="Logo"/>
                <img src={LogoIfpb} alt="Logo IFPB"/>
             </div>
              
          </div>

          <span>© 2020 Loopis JR</span> 
      </footer>
  
    </div>
  )
}